import { call, put, takeEvery } from "redux-saga/effects";
import { apis } from "../../config/APIs";
import endpoint from "../../config/Axios";
import { Dashboard } from "./dashboard";

function* dashboard(req) {
  let res = null;

  try {
    res = yield call(endpoint["get"], apis.dashboard, {
      params: req.payload,
      skipSuccessMessage: true,
    });

    if (res.status < 400) {
      if (req && req.payload)
        yield put({
          type: Dashboard.SUCCESS,
          payload: res.data,
          reqPayload: req.payload,
        });
      else
        yield put({
          type: Dashboard.SUCCESS,
          payload: res.data,
        });
    } else {
      yield put({
        type: Dashboard.FAILED,
        payload: res.data,
      });
    }
  } catch (err) {
    yield put({
      type: Dashboard.FAILED,
      payload: err?.response?.data,
    });
  }
}

export function* dashboardWatcher() {
  yield takeEvery(Dashboard.REQUEST, dashboard);
}
